module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-12.7750f596.svg";